import React, { Component } from 'react';
import ContainerSection from './ContainerSection';
import MultiSection from './MultiSection';
import Translator from "../../requests/apa/Translator";
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
class Section extends Component {
    constructor(props) {
      super(props);
      this.flagEnabled = true;
      // this.optionaTitle = null;
    }

    titleSection() {
      let optionaTitle = null;
      if(this.props.optionaTitle.length > 0 ) {
       if(this.props.optionaTitle.filter)
        optionaTitle = this.props.optionaTitle.filter(opTitle => opTitle.id === this.props.section);
       else
         optionaTitle=[{title:this.props.optionaTitle}];
      }

      return optionaTitle[0] ? optionaTitle[0].title : this.props.section;
    }

    render() {
        let subsectionName = '';
        let showHeader = true;

        if (this.props.subsection) {
            subsectionName = ` / ${this.props.subsection}`
        }
        if(MultipleLangLive.isEnabled() && (this.props.section && (typeof this.props.section == 'string') && this.props.section == 'idioma')){
          showHeader = false;
        }else{
          showHeader = true;
        }
        if(this.props.section ==='parental_control'){
          return(<MultiSection sectionOneName={'parental_control_tv_config'} sectionTwoName={'parental_control_content_config'} subsection={ this.props.subsection } />);
        }else
        return (
            <div id="section" className="content-view">
              {showHeader && <div className="header-settings">
                    { this.titleSection() }<span>{ subsectionName }</span>
                </div>
              }
              {showHeader && <hr/>
              }
                <ContainerSection section={ this.props.section } subsection={ this.props.subsection } />
            </div>
        );
    }
}

export default Section;



// WEBPACK FOOTER //
// ./src/containers/User-Settings/Section.jsx